type TourRestartCallback = () => void;

let currentRestartFn: TourRestartCallback | null = null;

export function registerTourRestart(fn: TourRestartCallback) {
  currentRestartFn = fn;
  return () => {
    currentRestartFn = null;
  };
}

export function triggerTourRestart() {
  currentRestartFn?.();
}
